export enum CreateWorkflow {
  CheckDuplicates = 'CHECK_DUPLICATES',
  AllowSave = 'ALLOW_SAVE',

}
